import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-both-normal",
  "use": "app-icon-arrow-both-normal-usage",
  "viewBox": "0 0 150 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 16\" id=\"app-icon-arrow-both-normal\"><g fill=\"#3DCCA6\" fill-rule=\"evenodd\"><path d=\"M9 5h130v5.647H9zM149.993 7.964l-10.927 7.529V.434z\" /><path d=\"M.066 7.964l10.927 7.529V.434z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol